import {
  COMPANIES_ACTIONS,
  DRIVERS_ACTIONS,
  INTEGRATIONS_API_ACTIONS,
  USERS_ACTIONS,
  VEHICLES_ACTIONS
} from "../../../../shared";

export const deleteActionsList = [
  VEHICLES_ACTIONS.DeleteVehicle,
  DRIVERS_ACTIONS.DeleteDriver,
  USERS_ACTIONS.DeleteUser,
  COMPANIES_ACTIONS.DeleteCompany,
  INTEGRATIONS_API_ACTIONS.DeleteCredential
];

export const removeSchedulesList = [
  VEHICLES_ACTIONS.RemoveSchedules,
  DRIVERS_ACTIONS.RemoveSchedules
];

export const quickSchedulesList = [VEHICLES_ACTIONS.QuickScheduleDownload];
